import { MultiSelectFilter } from "components/DesignSystem/Filter/Filter";
import Loader from "components/DesignSystem/Loader/loader";
import { useGetBaseTaskTemplatesQuery } from "store/apis/getTemplates";
import React from "react";

export const BaseTaskTemplateFilter = ({
  onUpdate,
  selectedTemplateFilter,
}: {
  onUpdate: (values: string[]) => void;
  selectedTemplateFilter?: string | null;
}) => {
  const { data, isLoading } = useGetBaseTaskTemplatesQuery({});
  const templates = Object.values(data || {}).flat();

  if (isLoading) {
    return (
      <div className="t-w-full t-h-full t-flex t-items-center t-justify-center">
        <Loader size="small" />
      </div>
    );
  }

  if (!templates || !templates.length) return null;

  return (
    <MultiSelectFilter
      onChange={onUpdate}
      options={templates.map((template) => ({
        value: template.uuid,
        label: template.title,
      }))}
      selected={selectedTemplateFilter?.split(",")}
    />
  );
};
